import { searchByPostalCode } from "../../../search-address";
/**
 * 出展をご検討中の方へ 画面の初期化
 */
export function initSampleSeriesConsideration() {
    initSearchAddressButton();
}
/**
 * 住所検索ボタンの初期化
 */
function initSearchAddressButton() {
    const button = document.getElementById("sample-series-consideration-search-address-button");
    if (button === null)
        return;
    button.addEventListener("click", async () => {
        const code1 = document.getElementById("postal-code-1").value;
        const code2 = document.getElementById("postal-code-2").value;
        const postalCode = code1 + '-' + code2;
        try {
            const data = await searchByPostalCode(postalCode);
            const options = document.getElementsByClassName("prefecture-option");
            for (const option of options) {
                if (option.value === data.prefecture) {
                    option.setAttribute('selected', 'selected');
                }
                else {
                    option.removeAttribute('selected');
                }
            }
            const input = document.getElementById("address1");
            input.value = data.address;
        }
        catch (error) {
            alert('住所が見つかりませんでした。');
        }
    });
}
